export class ListBackupPostureControlsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupPostureControls",
            "baseName": "backupPostureControls",
            "type": "Array<BackupPostureControl>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListBackupPostureControlsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
